import Skeleton from '@ui/Skeleton';
import React from 'react';

function TweetPlaceholder(props) {
  return (
    <div className="flex justify-center w-full">
      <div className="flex flex-col gap-2 w-[590px] h-80 items-center border rounded-md p-5">
        <div className="flex gap-6 w-full">
          <Skeleton variant="circle" className="!w-10 !h-10" />
          <div className="flex flex-col justify-between items-start w-full">
            <Skeleton variant="rect" className="w-full h-4" />
            <Skeleton variant="rect" className="w-full h-4" />
          </div>
        </div>
        <Skeleton variant="rect" className="w-full h-full" />
      </div>
    </div>
  );
}

export default TweetPlaceholder;
